import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _regeneratorRuntime from "@babel/runtime/regenerator";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import { connect } from 'react-redux';
import { translate } from '@haldor/ui';
import { createStudentAdjustment, getStudentAdjustments } from 'actions/additional_adjustments';
import User from '_class/User';
import sniffer from 'sniffer';
import { Collapsible, Spinner } from 'UI';
import { Icon, Flex, Button } from '@haldor/ui';
import Modal from 'containers/Modals/Modal';
import StudentAdjustmentForm from 'containers/AdditionalAdjustments/Form/StudentAdjustmentForm';
import StudentAdjustment from 'containers/AdditionalAdjustments/Display/StudentAdjustment';

var AdditionalAdjustments = /*#__PURE__*/function (_Component) {
  _inherits(AdditionalAdjustments, _Component);

  var _super = _createSuper(AdditionalAdjustments);

  function AdditionalAdjustments(props) {
    var _this;

    _classCallCheck(this, AdditionalAdjustments);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "componentDidMount", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var _this$props, start, end;

      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this$props = _this.props, start = _this$props.start, end = _this$props.end;
              _context.next = 3;
              return _this.props.getStudentAdjustments(_this.props.user, start, end);

            case 3:
              _this.setState({
                loading: false
              });

            case 4:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    })));

    _defineProperty(_assertThisInitialized(_this), "componentWillReceiveProps", /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(nextProps) {
        var start, end;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                start = nextProps.start, end = nextProps.end;

                if (!(nextProps.start == _this.props.start && nextProps.end == _this.props.end)) {
                  _context2.next = 3;
                  break;
                }

                return _context2.abrupt("return", false);

              case 3:
                if (!(_this.props.start != start || _this.props.end != end)) {
                  _context2.next = 8;
                  break;
                }

                _this.setState({
                  loading: true
                });

                _context2.next = 7;
                return _this.props.getStudentAdjustments(_this.props.user, start, end);

              case 7:
                _this.setState({
                  loading: false
                });

              case 8:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      return function (_x) {
        return _ref2.apply(this, arguments);
      };
    }());

    _defineProperty(_assertThisInitialized(_this), "toggleModal", function () {
      _this.setState({
        modal: !_this.state.modal
      });
    });

    _defineProperty(_assertThisInitialized(_this), "createStudentAdjustment", function (values) {
      return new Promise(function (resolve) {
        _this.props.createStudentAdjustment(values).then(function () {
          _this.setState({
            modal: false
          });

          _this.props.getStudentAdjustments(_this.props.user);
        });
      });
    });

    _this.state = {
      modal: false,
      loading: true
    };
    return _this;
  }

  _createClass(AdditionalAdjustments, [{
    key: "render",
    value: function render() {
      if (this.props.studentAdjustments == null) {
        return null;
      }

      var translate = this.props.translate;

      if (this.state.loading) {
        return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Flex, {
          center: true
        }, /*#__PURE__*/React.createElement("h2", {
          className: "c--title",
          style: {
            flex: 1
          }
        }, translate('additional-adjustments'))), /*#__PURE__*/React.createElement(Spinner, {
          center: true
        }));
      }

      var active = this.props.studentAdjustments.filter(function (adjustment) {
        if (adjustment == null) return false;
        return adjustment.status == 'ACTIVE';
      });
      var completed = this.props.studentAdjustments.filter(function (adjustment) {
        if (adjustment == null) return false;
        return adjustment.status == 'COMPLETED';
      });
      var deleted = this.props.studentAdjustments.filter(function (adjustment) {
        if (adjustment == null) return false;
        return adjustment.status == 'DELETED';
      });
      var currentUser = new User(this.props.currentUser);
      return /*#__PURE__*/React.createElement("div", null, !currentUser.isStudent() ? /*#__PURE__*/React.createElement(Modal, {
        isOpen: this.state.modal,
        onClose: this.toggleModal,
        title: translate('new-adjustment')
      }, /*#__PURE__*/React.createElement(StudentAdjustmentForm, {
        onSubmit: this.createStudentAdjustment,
        onClose: this.toggleModal,
        userId: this.props.user
      })) : null, /*#__PURE__*/React.createElement(Flex, {
        center: true
      }, /*#__PURE__*/React.createElement("h2", {
        className: "c--title",
        style: {
          flex: 1
        }
      }, translate('additional-adjustments')), !currentUser.isStudent() && !sniffer.isDevice ? /*#__PURE__*/React.createElement(Button, {
        onClick: this.toggleModal
      }, /*#__PURE__*/React.createElement(Icon, {
        name: "Plus"
      }), translate('assign-adjustment')) : null), /*#__PURE__*/React.createElement("div", {
        style: {
          marginTop: '1rem'
        }
      }), this.props.studentAdjustments.length == 0 ? /*#__PURE__*/React.createElement("div", {
        className: "color--meta weight--bold text--center"
      }, translate('no-additional-adjustments')) : null, active.map(function (adjustment) {
        return /*#__PURE__*/React.createElement(StudentAdjustment, {
          key: adjustment.id,
          adjustment: adjustment
        });
      }), !currentUser.isStudent() && sniffer.isDevice ? /*#__PURE__*/React.createElement(Button, {
        onClick: this.toggleModal
      }, /*#__PURE__*/React.createElement(Icon, {
        name: "Plus"
      }), translate('assign-adjustment')) : null, /*#__PURE__*/React.createElement("div", {
        style: {
          marginTop: '1rem'
        }
      }), completed.length > 0 ? /*#__PURE__*/React.createElement(Collapsible, {
        trigger: this.props.translate('completed')
      }, completed.map(function (adjustment) {
        return /*#__PURE__*/React.createElement(StudentAdjustment, {
          key: adjustment.id,
          adjustment: adjustment
        });
      })) : null, /*#__PURE__*/React.createElement("div", {
        style: {
          marginTop: '1rem'
        }
      }), currentUser.isPedagogue() && deleted.length > 0 ? /*#__PURE__*/React.createElement(Collapsible, {
        trigger: this.props.translate('Deleted')
      }, deleted.map(function (adjustment) {
        return /*#__PURE__*/React.createElement(StudentAdjustment, {
          key: adjustment.id,
          adjustment: adjustment
        });
      })) : null);
    }
  }]);

  return AdditionalAdjustments;
}(Component);

function mapStateToProps(state) {
  return {
    translate: translate(state.Languages.translations),
    studentAdjustments: state.AdditionalAdjustments.studentAdjustments,
    currentUser: state.user.currentUser
  };
}

export default connect(mapStateToProps, {
  getStudentAdjustments: getStudentAdjustments,
  createStudentAdjustment: createStudentAdjustment
})(AdditionalAdjustments);